import React from 'react'
import { withRouter } from 'react-router-dom'
import DashboardSingleClientComposeNoteContainer from './compose-note-container'
import DashboardSingleClientNoteContainer from './single-note-container'
import DashboardSingleClientNoNotesContainer from './no-notes-container'
import { useSelector } from 'react-redux'
import { TableLoader } from '../../../../../library/table-loader'
import './style.scss'

const Index = () => {

	const clientNotes = useSelector(state => state.singleClient.notes)
	const loading = useSelector(state => state.singleClient.fetchNotes.loading)
	

	return(
		<div className="tab-pane single-client-all-notes-tab show active fade" id="nav-all-notes" role="tabpanel" aria-labelledby="nav-all-notes-tab">
			<div className="all-notes-container">
				<div className="all-written-notes-container">
					{!loading && clientNotes && clientNotes.length > 0 && 
						clientNotes.map((singleNote, index, arr) => {
							return(<DashboardSingleClientNoteContainer singleNote={singleNote} index={index} arr={arr} />)
						})
					}
					{!loading && clientNotes && clientNotes.length === 0 && <DashboardSingleClientNoNotesContainer/>}
					{loading ? <TableLoader/>:null}
				</div>
				<DashboardSingleClientComposeNoteContainer/>
			</div>
		</div>
	)
}

export default withRouter(Index)
